import EventInfo from '../EventInfo';
import { useRouter } from 'next/router';
import { useEventAnalyticsRevenueSummary } from 'legacy/events/hooks/useEventAnalyticsRevenueSummary';
import { currencyFormat } from 'legacy/common/utils/currency';

const EventFinancialsSummary = () => {
  const router = useRouter();

  const eventId = router.query.slug as string;
  const { data } = useEventAnalyticsRevenueSummary({ eventId });

  const eventData = [
    {
      label: 'Gross Revenue',
      value: data?.grossRevenue,
      format: (val) => `${currencyFormat(val)}`
    },
    {
      label: 'Net Revenue',
      value: data?.netRevenue,
      format: (val) => `${currencyFormat(val)}`
    },
    {
      label: 'Gross Sales',
      value: data?.grossSales,
      format: (val) => `${currencyFormat(val)}`
    },
    {
      label: 'Net Sales',
      value: data?.netSales,
      format: (val) => `${currencyFormat(val)}`
    },
    {
      label: 'Tax',
      value: data?.taxes,
      format: (val) => `${currencyFormat(val)}`
    },
    {
      label: 'Organizer Fee',
      value: data?.organizerFees,
      format: (val) => `${currencyFormat(val)}`
    },
    {
      label: 'Marketing Fee',
      value: data?.marketingFees,
      format: (val) => `${currencyFormat(val)}`
    }
  ];
  return <EventInfo data={eventData} />;
};

export default EventFinancialsSummary;
